// @flow
import { useJsonForms, ctxToControlProps } from '@jsonforms/react';

type ViewProps = {
    data: $FixMe,
    label: string,
    uischema: $FixMe
};

const useViewProps = (props: $FixMe): ViewProps => {
    const ctx = useJsonForms();
    const { data, label, uischema } = ctxToControlProps(ctx, props);

    return {
        data,
        label,
        uischema
    };
};

export default useViewProps;
